export const aboutMeEN = {
  title: 'WHO IS JONATHAN ARAUJO?',
  info: [
    {
      id: 1,
      paragraph: 'I am a developer passionate about creating innovative products that are efficient and promote a great impact on society. I have a basic English (A2), although it is not very fluent, it helps me to read documentation without problems.'
    },
    {
      id: 2,
      paragraph: 'I am a proactive developer, I devote between 8-12hrs of programming, I like to implement the best practices when developing and creating an impeccable code; In addition to this I like to occasionally share my knowledge through publications in medium or online education communities.'
    }
  ],
  skills: {
    callToAction: 'WHAT I DO!',
    stacks: [
      {
        id: 1,
        stack_title: 'Front End',
        icon: 'fab fa-react',
        technologies: 'React.js, Redux, React Router, Next.js, React Native, React Navigation, Angular 6 and TypeScript'
      },
      {
        id: 2,
        stack_title: 'Preprocessors and Frameworks CSS',
        icon: 'fas fa-layer-group',
        technologies: 'Styled Components, Styled JSX, Sass, Less, PostCSS, Bootstrap 4, Foundation, Pure CSS and Semantic UI'
      },
      {
        id: 3,
        stack_title: 'Back End',
        icon: 'fas fa-fill-drip',
        technologies: 'Node.js, Express.js, MongoDB and Hapi.js'
      },
      {
        id: 4,
        stack_title: 'Technologies / Skills extra',
        icon: 'fas fa-plus',
        technologies: 'Webpack, Jest, Enzyme, Mocha.js, Git, WPO; Web Performance Optimization'
      }
    ]
  }
};

export const aboutMeES = {
  title: 'QUIEN ES JONATHAN ARAUJO?',
  info: [
    {
      id: 1,
      paragraph: 'Soy un desarrollador apasionado por crear productos innovadores  que sean eficientes y promuevan un gran impacto en la sociedad.  Tengo un inglés básico (A2), aunque no es muy fluido me ayuda  a leer documentaciones sin problemas. Soy un desarrollador proactivo,  dedico entre 8-12hrs de programación.'
    },
    {
      id: 2,
      paragraph: 'Me gusta implementar las mejores prácticas  al momento de desarrollar y crear un código impecable; tomando en cuenta  que al desarrollar con buenas prácticas "tu yo el futuro" te lo agradecerá  o sencillamente algún colega si le toca mantener el código. me gusta compartir ocasionalmente mis conocimientos a través de publicaciones en médium o comunidades de educación online.'
    }
  ],
  skills: {
    callToAction: '¡CONOCE MIS HABILIDADES!',
    stacks: [
      {
        id: 1,
        stack_title: 'Front-End',
        icon: 'fab fa-react',
        technologies: 'React.js, Redux, React Router, Next.js, React Native, React Navigation, Angular 6 and TypeScript.'
      },
      {
        id: 2,
        stack_title: 'Preprocesadores y Frameworks CSS',
        icon: 'fas fa-layer-group',
        technologies: 'Styled Components, Styled JSX, Sass, Less, PostCSS, Bootstrap 4, Foundation, PureCSS y Semantic UI'
      },
      {
        id: 3,
        stack_title: 'Back-End',
        icon: 'fas fa-fill-drip',
        technologies: 'Node.js, Express.js, MongoDB y Hapi.js'
      },
      {
        id: 4,
        stack_title: 'Tecnologias / Habilidades extra',
        icon: 'fas fa-plus',
        technologies: 'Webpack, Jest, Enzyme, Mocha.js Git, WPO; Optimización de rendimiento web.'
      }
    ]
  }
};

export const aboutMeIcons = [
  {
    id: 1,
    isClass: 'fa--node',
    src: '/images/icons/node.png',
    alt: 'node-icon',
    top: '265px',
    left: '15%'
  },
  {
    id: 2,
    isClass: 'fa--react',
    src: '/images/icons/react.png',
    alt: 'react-icon',
    top: '175px',
    left: '70%'
  },
  {
    id: 3,
    isClass: 'fa--sass',
    src: '/images/icons/sass.png',
    alt: 'sass-icon',
    top: '35px',
    left: '0%'
  },
  {
    id: 4,
    isClass: 'fa--bootstrap',
    src: '/images/icons/bootstrap.png',
    alt: 'bootstrap-icon',
    top: '205px',
    left: '0'
  },
  {
    id: 5,
    isClass: 'fa--gitlab',
    src: '/images/icons/gitlab.png',
    alt: 'gitlab-icon',
    top: '305px',
    left: '40%'
  },
  {
    id: 6,
    isClass: 'fa--git',
    src: '/images/icons/git.png',
    alt: 'git-icon',
    top: '270px',
    left: '80%'
  },
  {
    id: 7,
    isClass: 'fa--redux',
    src: '/images/icons/redux.png',
    alt: 'redux-icon',
    top: '25px',
    left: '85%'
  },
  {
    id: 8,
    isClass: 'fa--csharp',
    src: '/images/icons/csharp.png',
    alt: 'csharp-icon',
    top: '5px',
    left: '20%'
  },
  {
    id: 9,
    isClass: 'fa--jest',
    src: '/images/icons/jest.png',
    alt: 'jest-icon',
    top: '45px',
    left: '65%'
  },
  {
    id: 10,
    isClass: 'fa--router',
    src: '/images/icons/react-router.png',
    alt: 'router-icon',
    top: '100px',
    left: '15%'
  },
  {
    id: 11,
    isClass: 'fa--nextjs',
    src: '/images/icons/nextjs.png',
    alt: 'nextjs-icon',
    top: '244px',
    left: '60%'
  },
  {
    id: 12,
    isClass: 'fa--firebase',
    src: '/images/icons/firebase.png',
    alt: 'firebase-icon',
    top: '20px',
    left: '40%'
  },
  {
    id: 13,
    isClass: 'fa--js',
    src: '/images/icons/js.png',
    alt: 'js-icon',
    top: '105px',
    left: '85%'
  },
  {
    id: 14,
    isClass: 'fa--react-navigation',
    src: '/images/icons/react-navigation.png',
    alt: 'react-navigation-icon',
    top: '175px',
    left: '25%'
  },
  {
    id: 15,
    isClass: 'fa--webpack',
    src: '/images/icons/webpack.png',
    alt: 'webpack-icon',
    top: '130px',
    left: '-5%'
  },
];
